import { render, staticRenderFns } from "./NumberOfRoomDamagesQuestion.vue?vue&type=template&id=dde5cb06"
import script from "./NumberOfRoomDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./NumberOfRoomDamagesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./NumberOfRoomDamagesQuestion.vue?vue&type=style&index=0&id=dde5cb06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports